export default __webpack_public_path__ + "static/media/hmro.02cbd200.md";